var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiTsAnswerAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.5,0H2.5C1.122,0,0,1.121,0,2.5v17.5h7.106l3.897,3.283c.286.254.645.38,1.001.38.353,0,.703-.123.979-.368l3.985-3.295h7.032V2.5c0-1.379-1.121-2.5-2.5-2.5Zm1.5,19h-6.392l-4.276,3.535c-.19.17-.476.169-.675-.009l-4.187-3.526H1V2.5c0-.827.673-1.5,1.5-1.5h19c.827,0,1.5.673,1.5,1.5v16.5ZM14,5h6v1h-6v-1Zm0,9h4v1h-4v-1Zm0-6h6v1h-6v-1Zm0,3h6v1h-6v-1ZM7.5,3.983c-.553,0-1.031.39-1.218.995l-3.282,11.021h1.046l1.19-4h4.528l1.19,4h1.046l-3.282-11.022c-.187-.604-.665-.994-1.218-.994Zm-1.966,7.017l1.703-5.726c.045-.145.143-.29.263-.29s.218.146.263.289l1.704,5.728h-3.933Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiTsAnswerAlt);
export default __webpack_public_path__ + "static/media/fi-ts-answer-alt.5ae019e4f9b304c257813647fe85ff80.svg";
export { ForwardRef as ReactComponent };